const LOCAL_ROLE_PREVIEW_MARKER = '__ihpLocalRolePreview'
const LOCAL_ROLE_PREVIEW_ROLES = Object.freeze([
    'admin',
    'veterinarian',
    'horseBreeder',
])

function normalizeHostname(hostname) {
    return String(hostname || '')
        .trim()
        .toLowerCase()
        .replace(/^\[|\]$/g, '')
        .replace(/\.$/, '')
}

function isLocalHostname(hostname) {
    const normalized = normalizeHostname(hostname)
    return normalized === 'localhost'
        || normalized.endsWith('.localhost')
        || normalized === '127.0.0.1'
        || normalized === '::1'
}

function getRuntime(runtime = {}) {
    const browserHostname = typeof window !== 'undefined'
        ? window.location.hostname
        : ''

    return {
        nodeEnv: runtime.nodeEnv ?? process.env.NODE_ENV,
        testEnv: runtime.testEnv ?? process.env.REACT_APP_TEST_ENV,
        hostname: runtime.hostname ?? browserHostname,
    }
}

function isLocalRolePreviewEnabled(runtime) {
    const currentRuntime = getRuntime(runtime)
    const testEnvEnabled = currentRuntime.testEnv === true
        || currentRuntime.testEnv === 'true'

    return currentRuntime.nodeEnv === 'development'
        && testEnvEnabled
        && isLocalHostname(currentRuntime.hostname)
}

function shouldActivateLocalRolePreview(
    pathname,
    runtime,
    hasSessionToken = false
) {
    if (!isLocalRolePreviewEnabled(runtime)) {
        return false
    }
    if (hasSessionToken) {
        return false
    }

    const path = String(pathname || '').split(/[?#]/, 1)[0]
    const segments = path.split('/').filter(Boolean)

    return segments.length === 0
}

function createLocalRolePreviewUser(role = 'admin') {
    if (!LOCAL_ROLE_PREVIEW_ROLES.includes(role)) {
        return null
    }

    const labels = {
        admin: 'Admin',
        veterinarian: 'Veterinarian',
        horseBreeder: 'Horse Breeder',
    }

    return {
        _id: `local-preview-${role}`,
        username: `preview-${role}`,
        name: 'Local Preview',
        family: labels[role],
        role,
        type: role,
        userType: role,
        permissions: role === 'admin' ? [{ permissions: '*' }] : [],
        [LOCAL_ROLE_PREVIEW_MARKER]: true,
    }
}

function isLocalRolePreviewSession(user, runtime) {
    return isLocalRolePreviewEnabled(runtime)
        && user?.[LOCAL_ROLE_PREVIEW_MARKER] === true
        && LOCAL_ROLE_PREVIEW_ROLES.includes(user?.userType)
}

export {
    LOCAL_ROLE_PREVIEW_MARKER,
    LOCAL_ROLE_PREVIEW_ROLES,
    createLocalRolePreviewUser,
    isLocalHostname,
    isLocalRolePreviewEnabled,
    isLocalRolePreviewSession,
    shouldActivateLocalRolePreview,
}
